import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { NavigationEnd, NavigationError, Router, RouterOutlet } from '@angular/router';
import { NgIf } from '@angular/common';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { LoadingComponent } from './shared/components';
import { LoadingService } from './core/services/loading.service';
import { TranslateService } from '@ngx-translate/core';
import { filter, Subscription } from 'rxjs';
import { NotificationMessageService } from './core/services/message.service';
import { ToastModule } from 'primeng/toast';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { RequestInterceptor } from './shared/services/request-interceptor';
import { AuthService } from './shared/services/auth.service';
import { IdleService } from './core/services/idle.service';
import { viLocale } from './core/configs/locale.vi';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    LoadingComponent,
    NgIf,
    ToastModule,

  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RequestInterceptor,
      multi: true,
    },
  ]
})
export class AppComponent implements OnInit, OnDestroy, AfterContentChecked {
  title = 'lms';
  loading = false;
  subscription: Subscription[] = [];
  subscriptionTranslate: any;
  loadedTranslate = false;
  visibleConfirm = false;
  configConfirm: any;

  constructor(
    private primeNGConfig: PrimeNGConfig,
    private loadingService: LoadingService,
    private router: Router,
    private service: NotificationMessageService,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService,
    private translate: TranslateService,
    private authService: AuthService,
    private idle: IdleService,
    private notify: NotificationMessageService,
  ) {
    translate.addLangs(['vn', 'en']);
    translate.use('vn');
    // this.seo.init('CRM');
    this.translate
      .get('primeng')
      .subscribe((res) => this.primeNGConfig.setTranslation(res));
    this.subscription.push(
      this.translate.stream('primeng').subscribe((data) => {
        this.primeNGConfig.setTranslation(data);
      })
    );
    this.subscriptionTranslate = this.translate
      .getTranslation(this.translate.currentLang)
      .subscribe(() => {
        this.loadedTranslate = true;
      });
    this.subscription.push(
      this.service.subjectMessage.subscribe((notify) => {
        this.messageService.add(notify);
      })
    );
    this.subscription.push(
      this.service.subjectDialog.subscribe((data) => {
        this.showConfirm(data);
      })
    );

    // this.streamData.data$.subscribe((data) => {
    //   if (data.key === APP_LOADING){
    //     this.loading = false;
    //   }
    // });

    this.router.events.subscribe((e) => {
      this.checkRouting(e);
    });
    this.primeNGConfig.setTranslation(viLocale);
  }

  showConfirm(data: any) {
    switch (data.key) {
      case 'confirm': {
        this.configConfirm = data;
        this.visibleConfirm = true;
        break;
      }
      default:
        break;
    }
  }

  ngOnInit() {
    this.primeNGConfig.ripple = true;
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        if (typeof window !== 'undefined') {
          window.scrollTo(0, 0);
        }
      });

    // Bật idle khi user đã login
    if (this.authService.isLoggedIn()) {
      this.startIdleWatcher();
    }

    // Bật idle khi user login từ màn đăng nhập
    this.authService.loginSuccess$.subscribe(() => {
      this.startIdleWatcher();
    });
  }

  startIdleWatcher() {
    this.idle.startWatching(() => {
      this.notify.info('Phiên đăng nhập của bạn đã hết hạn!');
      setTimeout(() => {
        this.authService.logout();
      }, 1000);
    });
  }

  ngOnDestroy() {
    this.idle.stopWatching();
  }

  ngAfterContentChecked() {
    this.loadingService.showLoading.subscribe((res: boolean) => {
      this.loading = res;
    });
    this.cdr.detectChanges();
  }

  checkRouting(e: any) {
    const urls = [
      '/notfound',
      '/under-maintenance',
      '/access-denied',
      '/login',
    ];

    const currentUrl = this.router.url;

    // Check not found route from navigation error
    if (e instanceof NavigationError) {
      if (e.error.code === 4002) {
        this.router.navigate(['/notfound']);
      }
    }


    if (urls.includes(currentUrl)) {
      this.loading = false;
    }
  }
}
